export enum TipoExclusaoAgendamento {
    Cancelado = 0,
    Finalizado = 1
}